import { Friend, User } from "src/lib/slices/userSlice";
import { transformImgSrc } from "./Image";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

export default function UserAvatar({
  friend,
  className,
}: {
  friend: Friend | User;
  className?: string;
}) {
  const firstLetterOfName = friend?.name
    ? friend.name.charAt(0).toUpperCase()
    : "U";

  return (
    <Avatar className={className}>
      <AvatarImage
        src={transformImgSrc(friend?.photo)}
        alt="Profilový obrázek"
      />
      <AvatarFallback>{firstLetterOfName}</AvatarFallback>
    </Avatar>
  );
}
